module.exports = __webpack_public_path__ + "static/media/metwo.fa118093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/about/metwo.jpg
// module id = 37
// module chunks = 0